
import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { RequisiteTypeListQuery } from '../core/query.types'
import { ApiResponse } from '../../../../../common/api/response.types'
import {
  IBaseMessageElement,
  IPaymentMethodLookupWithRequisiteType,
  IRequisiteType,
  IRequisiteBalanceOperation,
} from './response.types'
import { RequisiteTypeBody } from './requests.types'

// ==================== PaymentMethod ====================

export const getPaymentMethodLookupWithRequisiteTypes = () => {
  return axios.get<ApiResponse<IPaymentMethodLookupWithRequisiteType[]>>(`${API_URL}/api/payment-method/lookup-with-requisite-types`)
}

// ==================== RequisiteType ====================

export const getRequisiteTypeList = (params: RequisiteTypeListQuery) => {
  return axios.get<ApiResponse<IRequisiteType[]>>(`${API_URL}/api/internal/requisite-type`, { params })
}

export const newRequisiteType = (data: RequisiteTypeBody) => {
  return axios.post<ApiResponse<IRequisiteType>>(`${API_URL}/api/internal/requisite-type`, data)
}

export const updateRequisiteType = (id: number, data: RequisiteTypeBody) => {
  return axios.post<ApiResponse<IRequisiteType>>(`${API_URL}/api/internal/requisite-type/${id}`, data)
}

export const toggleEnableRequisiteType = (id: number) => {
  return axios.patch<ApiResponse<IBaseMessageElement>>(`${API_URL}/api/internal/requisite-type/${id}/toggle-enable`)
}

// ==================== Requisite Balance Operations ====================

export interface IOperationsListResponse {
  success: boolean
  totalRows: number
  data: IRequisiteBalanceOperation[]
}

export interface IManualOperationResponse {
  success: boolean
  data: {
    operationId: number
    requisiteId: number
    newBalance: number
    createdAt: string
  }
}

export const getRequisiteOperations = (
  requisiteId: number,
  params?: { dateStart?: string; dateEnd?: string; page?: number; perPage?: number }
) =>
  axios.get<IOperationsListResponse>(
    `${API_URL}/api/internal/requisite/${requisiteId}/operations`,
    { params }
  )

export const postManualOperation = (
  requisiteId: number,
  data: { amount: number; comment: string }
) =>
  axios.post<IManualOperationResponse>(
    `${API_URL}/api/internal/requisite/${requisiteId}/manual-operation`,
    data
  )
